module.exports = __webpack_public_path__ + "img/slightly_smiling_emoji.dc6ab95.png";